import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IconComponent} from "../icon/icon.component";

@Component({
    selector: 'app-boolean-indicator',
    imports: [
        IconComponent,
    ],
    templateUrl: './boolean-indicator.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './boolean-indicator.component.scss'
})
export class BooleanIndicatorComponent {
  @Input() state!: boolean;
}
